import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, unref as _unref, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "label" }

import { ref, computed, watch, onMounted, onUnmounted } from "vue";
  import { trans } from "@/utils/trans";
  import { format_currency } from "@/utils/currencies";
  import { useAuctionStore } from "@/stores/AuctionStore";
  import { ILot } from "@/models";
  import { LotSoldStatuses } from "@/enum";

  
export default /*#__PURE__*/_defineComponent({
  __name: 'BidStatus',
  props: {
    hiddenPendingProp: {
      type: Boolean,
      default: false
    }
  },
  setup(__props) {

  const props = __props;

  const messages = {
    pending: trans("live.catalog.bid_statuses.pending"),
    leading: trans("live.catalog.bid_statuses.leading"),
    outbid: trans("live.catalog.bid_statuses.outbid"),
    won: trans("live.catalog.bid_statuses.won")
  };

  const auctionStore = useAuctionStore();
  const popupLot = computed(() => auctionStore.popupLot as ILot);
  const userBid = computed(() => auctionStore.popupLot?.user_bid ?? 0);
  const isUserBidLeading = computed(() => popupLot?.value.leader_id === auctionStore.user?.id);

  const isChangeBid = ref(false);

  const labelText = computed(() => {
    if (popupLot.value.sold_status === LotSoldStatuses.SOLD) {
      if (userBid.value) {
        return isUserBidLeading.value ? messages.won : messages.outbid;
      }
      return "";
    } else {
      if (userBid.value) {
        return isUserBidLeading.value ? messages.leading : messages.outbid;
      }
      return props.hiddenPendingProp ? "" : messages.pending;
    }
  });

  watch(
    () => userBid.value,
    () => {
      setTimeout(() => {
        isChangeBid.value = true;
        setTimeout(() => {
          isChangeBid.value = false;
        }, 250);
      }, 300);
    }
  );

  watch(
    () => isUserBidLeading.value,
    (newValue, oldValue) => {
      if (newValue !== oldValue && !isChangeBid.value) {
        setTimeout(() => {
          isChangeBid.value = true;
          setTimeout(() => {
            isChangeBid.value = false;
          }, 250);
        }, 300);
      }
    }
  );

return (_ctx: any,_cache: any) => {
  return (labelText.value.length)
    ? (_openBlock(), _createElementBlock("div", {
        key: 0,
        class: _normalizeClass([
      'lot-card__status-bid',
      {
        good: userBid.value && isUserBidLeading.value,
        warning: userBid.value && !isUserBidLeading.value
      }
    ])
      }, [
        _createElementVNode("div", _hoisted_1, [
          _createElementVNode("span", null, _toDisplayString(labelText.value), 1)
        ]),
        (userBid.value)
          ? (_openBlock(), _createElementBlock("div", {
              key: 0,
              class: _normalizeClass(['value', { 'animation-process': isChangeBid.value }])
            }, _toDisplayString(_unref(format_currency)(userBid.value)), 3))
          : _createCommentVNode("", true)
      ], 2))
    : _createCommentVNode("", true)
}
}

})